import { Fragment } from "react";
import { Dialog, Transition } from "@headlessui/react";
import { ReactComponent as CloseIcon } from "../../../assets/icons/close.svg";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default function Modal(_ref) {
  let {
    isOpen,
    onClose,
    children,
    showCloseButton = true,
    padding,
    ...props
  } = _ref;
  return /*#__PURE__*/_jsx(Transition.Root, {
    show: isOpen,
    as: Fragment,
    children: /*#__PURE__*/_jsxs(Dialog, {
      as: "div",
      className: "fixed inset-0 z-40 flex items-center justify-center mx-5 sm:mx-10",
      style: {
        scrollbarWidth: "none",
        msOverflowStyle: "none"
      },
      onClose: onClose,
      children: [/*#__PURE__*/_jsx(Transition.Child, {
        as: Fragment,
        enter: "ease-out duration-300",
        enterFrom: "opacity-0",
        enterTo: "opacity-100",
        leave: "ease-in duration-200",
        leaveFrom: "opacity-100",
        leaveTo: "opacity-0",
        children: /*#__PURE__*/_jsx("div", {
          className: "fixed inset-0 bg-grey-400 bg-opacity-75 transition-opacity"
        })
      }), /*#__PURE__*/_jsx(Transition.Child, {
        as: Fragment,
        enter: "ease-out duration-300",
        enterFrom: "opacity-0 scale-95",
        enterTo: "opacity-100 scale-100",
        leave: "ease-in duration-200",
        leaveFrom: "opacity-100 scale-100",
        leaveTo: "opacity-0 scale-95",
        children: /*#__PURE__*/_jsxs(Dialog.Panel, {
          className: `relative bg-white rounded-3xl text-left shadow-xl transform transition-all overflow-x-auto ${padding ? padding : "p-10"}`,
          style: {
            scrollbarWidth: "none",
            msOverflowStyle: "none"
          },
          children: [showCloseButton && /*#__PURE__*/_jsx("button", {
            type: "button",
            className: "absolute z-20 top-6 right-6 text-grey-400 hover:text-grey-500",
            onClick: () => {
              if (props.redirectUrl) {
                window.location.href = props.redirectUrl;
              }
              onClose();
            },
            children: /*#__PURE__*/_jsx(CloseIcon, {
              className: "size-5"
            })
          }), /*#__PURE__*/_jsx("div", {
            className: "max-h-[90vh] overflow-y-auto",
            children: children
          })]
        })
      })]
    })
  });
}